import React from 'react'
import { AutocompleteInput, AutocompleteInputProps } from 'react-admin'
import LocalizedFieldWithChoices from './LocalilzedFieldWithChoices'

const LocalizedAutocomplete: React.FC<AutocompleteInputProps> = (props) => (
  <LocalizedFieldWithChoices {...props}>
    <AutocompleteInput />
  </LocalizedFieldWithChoices>
)

export default LocalizedAutocomplete
